export default __webpack_public_path__ + "static/media/warning-circle.9fd6b8b8.svg";